module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zhHant":{"title":"ACC 管理系統","pageName":"主頁"}}')
  delete Component.options._Ctor
}
